const Loader = () => {
    return (
        <div className='flex justify-center items-center'>
            <div className='w-20 h-20 border-4 border-blue-500 rounded-full border-t-transparent border-l-transparent border-r-transparent animate-spin'></div>
        </div>
    );
};

export default Loader;
